<div class="h-100 d-flex justify-content-end align-items-center gap-20 fs-5">
  <i class="cp far fa-file-excel" (click)="onClick('reportDownload')" tooltip="Download Tests XLSX" *ngIf="!!currentRow.reportReference"></i>
  <i class="cp far fa-eye" (click)="onClick('view')" tooltip="View"></i>
  <i class="cp fas fa-file-invoice-dollar" (click)="onClick('generateZohoReport')" tooltip="Generate Invoice"
    *ngIf="this.user?.role === Role.ADMIN && !currentRow.zohoId"></i>
  <i class="cp fas fa-file-invoice-dollar" (click)="onClick('generateZohoReport')" tooltip="Regenerate Invoice"
    *ngIf="this.user?.role === Role.ADMIN && !!currentRow.zohoId"></i>
  <i class="cp fa fa-file-download" (click)="onClick('downloadZohoReport')" tooltip="Download PDF Invoice" *ngIf="!!currentRow.zohoId"></i>
  <i class="cp far fa-paper-plane" (click)="onClick('sendZohoReport')" tooltip="Send email from Zoho"
    *ngIf="!!currentRow.zohoId && this.user?.role === Role.ADMIN"></i>
  <i class="cp far fa-trash-alt text-error-r3" (click)="onClick('delete')" tooltip="Delete" *ngIf="canShowActionDelete()"></i>
</div>
